var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_802_31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.172 116.594L139.4 4.82799C132.967 -1.60901 122.527 -1.60901 116.086 4.82799L92.876 28.038L122.319 57.481C129.161 55.169 137.007 56.72 142.461 62.174C147.941 67.663 149.481 75.576 147.113 82.44L175.488 110.816C182.353 108.451 190.274 109.981 195.757 115.473C203.42 123.133 203.42 135.548 195.757 143.213C188.092 150.879 175.677 150.879 168.008 143.213C162.244 137.443 160.82 128.978 163.738 121.877L137.276 95.415L137.273 165.052C139.191 166 140.943 167.253 142.461 168.762C150.124 176.422 150.124 188.838 142.461 196.509C134.796 204.171 122.375 204.171 114.721 196.509C107.058 188.838 107.058 176.423 114.721 168.763C116.557 166.926 118.74 165.471 121.142 164.482V94.196C118.736 93.2139 116.553 91.7581 114.721 89.915C108.915 84.117 107.519 75.598 110.494 68.469L81.47 39.442L4.83 116.077C-1.61 122.52 -1.61 132.961 4.83 139.399L116.604 251.167C123.039 257.605 133.477 257.605 139.92 251.167L251.171 139.918C257.609 133.478 257.609 123.031 251.171 116.594",
    fill: "#DE4C36"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_802_31"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGit);
export default __webpack_public_path__ + "static/media/git.209e776bcf0cb749fbe8d8b56cd4c143.svg";
export { ForwardRef as ReactComponent };